import { render, staticRenderFns } from "./fktable.vue?vue&type=template&id=857d6718"
import script from "./fktable.vue?vue&type=script&lang=js"
export * from "./fktable.vue?vue&type=script&lang=js"
import style0 from "./fktable.vue?vue&type=style&index=0&id=857d6718&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports